import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerService } from '../../../services/customer.service';
import { Location } from '@angular/common';
@Component({
  selector: 'app-view-customer',
  templateUrl: './view-customer.component.html',
  styleUrls: ['./view-customer.component.css']
})
export class ViewCustomerComponent implements OnInit {
  consumerDetails: any;
  consumerId: number;
  constructor(private activatedRoute: ActivatedRoute, private location: Location,private customerService: CustomerService, private router: Router) { }
  ngOnInit() {

   this.customerService.getDetails(this.activatedRoute.snapshot.params['id'])
   .subscribe(res => {
    this.consumerDetails = res;

  });
  // this.customerService.getDataForm()
  // .subscribe(res => {
  //   alert('obj' + JSON.stringify(res));
  // });
  }
  // goBacktoList() {
  //   this.router.navigate(['../../list'], { relativeTo: this.activatedRoute });
  // }
  goBacktoListt() {
    this.location.back();
  }

}
